import { render, staticRenderFns } from "./PriorityTypeInfo.vue?vue&type=template&id=6167147c&"
import script from "./PriorityTypeInfo.vue?vue&type=script&lang=js&"
export * from "./PriorityTypeInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports